//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import headDetails from "@/components/headDetails";
import { uploadFile } from "@/utils/auth";
import { Dialog, Toast } from "vant";
import homeTip from "@/components/homeTip";

export default {
  name: "procurementClearance",
  components: {
    footerNav,
    homeTip,
    headDetails
  },
  data() {
    return {
      defaultIndex: -12,
      loading: false,
      isPlan: false,
      submitLoading: false,
      planOrderId: "",
      basicForm: {
        planIssueQty: "",
        planOrderSn: "",
        issueNum: 0,
        secondDeptName: "",
        planQty: 0,
        procurementList: []
      },
      planDetailList: [],
      issueId: "",
      detailList: [],
      areaList: [],
      supervisorList: [],
      supervisorListCopy: [],
      supplierList: [],
      supplierListCopy: [],
      isSupplier: false,
      id: "",
      XiaBiao: "",
      planQty: "",
      planIssueNum: "",
      supplierName: "",
      ret: [],
      typeFlag: "",
      showPicker: false,
      showOrderGenre: false,
      showSeason: false,
      positionSearch: "",
      orderGenreSearch: "",
      seasonOnSearch: "",
      typeFlagUser: "",
      showPickerUser: false,
      positionSearchUser: "",
      total: 0,
      start: 0,
      supstart: -1,
      orderGenreList: [],
      orderGenreListCopy: [],
      SeasonList: [],
      SeasonListCopy: [],
      supplierAllList: []
    };
  },
  created() {
    if (this.$route.query.planOrderId instanceof Array) {
      this.planDetailList = this.$route.query.planOrderId;
    } else {
      this.planDetailList = [this.$route.query.planOrderId];
    }
  },
  mounted() {
    this.queryData();
  },
  watch: {
  },
  methods: {
    supercancel() {
      this.showPicker = false;
      this.ret = [];
    },
    orderGenreSupercancel() {
      this.showOrderGenre = false;
      this.ret = [];
    },
    seasonSupercancel() {
      this.showSeason = false;
      this.ret = [];
    },
    showPickercancel() {
      this.showPickerUser = false;
      this.ret = [];
    },
    changePicker(flag, id) {
      this.id = id;
      this.typeFlag = flag;
      this.supervisorList = this.supervisorListCopy;
      if (flag === 1) {
        this.positionSearch = "";
      }
      this.ret = [];
      this.showPicker = true;
      this.getPositionList(1);
    },
    changeOrderGenre(flag, id) {
      this.id = id;
      this.typeFlag = flag;
      this.orderGenreList = this.orderGenreListCopy;
      if (flag === 1) {
        this.orderGenreSearch = "";
      }
      this.ret = [];
      this.showOrderGenre = true;
      this.getOrderGenreList(1);
    },
    getOrderGenreList(type) {
      if (type === 1) {
        this.orderGenreList.forEach(item => {
          if (this.orderGenreSearch) {
            if (item.lable.indexOf(this.orderGenreSearch) > -1) {
              this.ret.push(item);
            }
          } else {
            this.ret.push(item);
          }
        });
        if (this.ret != []) {
          this.orderGenreList = this.ret;
        } else {
          this.orderGenreList = this.orderGenreListCopy;
        }
      }
    },
    changeSeason(flag, id) {
      this.id = id;
      this.typeFlag = flag;
      if (flag === 1) {
        this.seasonOnSearch = "";
      }
      this.SeasonList = this.SeasonListCopy;
      this.ret = [];
      this.showSeason = true;
      this.getSeasonList(1);
    },
    getSeasonList(type) {
      if (type === 1) {
        this.SeasonList.forEach(item => {
          if (this.seasonOnSearch) {
            if (item.lable.indexOf(this.seasonOnSearch) > -1) {
              this.ret.push(item);
            }
          } else {
            this.ret.push(item);
          }
        });
        if (this.ret != []) {
          this.SeasonList = this.ret;
        } else {
          this.SeasonList = this.SeasonListCopy;
        }
      }
    },
    onChange(picker, value, index) {
      this.positionSearch = value.lable;
      var multiple = (index + 1) / 12;
      if (Number.isInteger(multiple)) {
        if (this.supstart < 54) {
          this.queryPage();
        }
      }
    },
    orderGenreChange(picker, value, index) {
      this.orderGenreSearch = value.lable;
    },
    seasonChange(picker, value, index) {
      this.seasonOnSearch = value.lable;
    },
    onSearch2(val) {
      this.ret = [];
      this.supplierAllList.forEach(item => {
        if (item.lable.indexOf(val) > -1) {
          this.ret.push(item);
        }
      });
      if (this.ret != []) {
        this.supervisorList = this.ret;
      } else {
        this.supervisorList = this.supervisorListCopy;
      }
    },
    onGenreSearch(val) {
      this.ret = [];
      this.orderGenreListCopy.forEach(item => {
        if (item.lable.indexOf(val) > -1) {
          this.ret.push(item);
        }
      });
      if (this.ret != []) {
        this.orderGenreList = this.ret;
      } else {
        this.orderGenreList = this.orderGenreListCopy;
      }
    },
    seasonSearch(val) {
      this.ret = [];
      this.SeasonListCopy.forEach(item => {
        if (item.lable.indexOf(val) > -1) {
          this.ret.push(item);
        }
      });
      if (this.ret != []) {
        this.SeasonList = this.ret;
      } else {
        this.SeasonList = this.SeasonListCopy;
      }
    },
    getPositionList(type) {
      if (type === 1) {
        this.supervisorList.forEach(item => {
          if (this.positionSearch) {
            if (item.lable.indexOf(this.positionSearch) > -1) {
              this.ret.push(item);
            }
          } else {
            this.ret.push(item);
          }
        });
        if (this.ret != []) {
          this.supervisorList = this.ret;
        } else {
          this.supervisorList = this.supervisorListCopy;
        }
      }
    },

    onConfirmPicker(value) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == this.id) {
          if (this.typeFlag === 1) {
            this.basicForm.procurementList[i].supplierName = value.lable;
            this.basicForm.procurementList[i].supplierId = value.value;
            this.XiaBiao = i;
          }
        }
      }
      this.showPicker = false;
      this.ret = [];
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.basicForm.planQty = response.content.planQty;
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    orderGenrePicker(value) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == this.id) {
          if (this.typeFlag === 1) {
            this.basicForm.procurementList[i].orderGenre = value.lable;
            this.basicForm.procurementList[i].orderGenreId = value.value;
            this.XiaBiao = i;
          }
        }
      }
      this.ret = [];
      this.showOrderGenre = false;
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.basicForm.planQty = response.content.planQty;
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    seasonPicker(value) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == this.id) {
          if (this.typeFlag === 1) {
            this.basicForm.procurementList[i].planningSeason = value.lable;
            this.basicForm.procurementList[i].planningSeasonId = value.value;
            this.XiaBiao = i;
          }
        }
      }
      this.showSeason = false;
      this.ret = [];
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    changePickerUser(flag, id) {
      this.id = id;
      this.typeFlagUser = flag;
      this.supplierList = this.supplierListCopy;
      if (flag === 1) {
        this.positionSearchUser = "";
      }
      this.ret = [];
      this.showPickerUser = true;
      this.getPositionListUser(1);
    },
    onChangeUser(picker, value, index) {
      this.positionSearchUser = value.lable;
    },
    onSearch2User(val) {
      this.ret = [];
      this.supplierListCopy.forEach(item => {
        if (item.lable.indexOf(val) > -1) {
          this.ret.push(item);
        }
      });
      if (this.ret != []) {
        this.supplierList = this.ret;
      } else {
        this.supplierList = this.supplierListCopy;
      }
    },
    getPositionListUser(type) {
      if (type === 1) {
        this.supplierList.forEach(item => {
          if (this.positionSearchUser) {
            if (item.lable.indexOf(this.positionSearchUser) > -1) {
              this.ret.push(item);
            }
          } else {
            this.ret.push(item);
          }
        });
        if (this.ret != []) {
          this.supplierList = this.ret;
        } else {
          this.supplierList = this.supplierListCopy;
        }
      }
    },
    onConfirmPickerUser(value) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == this.id) {
          if (this.typeFlagUser === 1) {
            this.basicForm.procurementList[i].supervisorUserName = value.lable;
            this.basicForm.procurementList[i].supervisorUserId = value.value;
            this.XiaBiao = i;
          }
        }
      }
      this.showPickerUser = false;
      this.ret = [];
      // this.supplierListCopy.forEach(item=>{
      //   if(item.lable == this.basicForm.procurementList[this.XiaBiao].)
      // })
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.basicForm.planQty = response.content.planQty;
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    editPlan(id) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == id) {
          if (this.basicForm.procurementList[i].planQty == "") {
            this.basicForm.procurementList[i].planQty = 0;
          }
          this.basicForm.procurementList[i].planQty = Number(
            this.basicForm.procurementList[i].planQty
          );
          this.XiaBiao = i;
        }
      }
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    editIssue(id) {
      for (let i = 0; i < this.basicForm.procurementList.length; i++) {
        if (this.basicForm.procurementList[i].id == id) {
          if (this.basicForm.procurementList[i].planIssueNum == "") {
            this.basicForm.procurementList[i].planIssueNum = 0;
          }
          this.basicForm.procurementList[i].planIssueNum = Number(
            this.basicForm.procurementList[i].planIssueNum
          );
          this.XiaBiao = i;
        }
      }
      var queryParams = { ...this.basicForm.procurementList[this.XiaBiao] };
      axiosApi
        .updateDetail(queryParams)
        .then(response => {
          this.basicForm.planQty = response.content.planQty;
          this.queryList();
        })
        .catch(error => {
          this.queryList();
        });
    },
    queryData() {
      axiosApi.optionSupplierList({}).then(response => {
        response.content.forEach(item => {
          this.supplierAllList.push({
            value: item.id,
            lable: item.name
          });
        });
      });
      axiosApi.getOptions({ optionCode: "orderGenre" }).then(response => {
        response.content.forEach(item => {
          this.orderGenreList.push({
            value: item.code,
            lable: item.name
          });
          this.orderGenreListCopy.push({
            value: item.code,
            lable: item.name
          });
        });
      });
      axiosApi.getOptions({ optionCode: "planningSeason" }).then(response => {
        response.content.forEach(item => {
          this.SeasonList.push({
            value: item.code,
            lable: item.name
          });
          this.SeasonListCopy.push({
            value: item.code,
            lable: item.name
          });
        });
      });
      axiosApi.manageList({}).then(response => {
        response.content.forEach(item => {
          this.supplierList.push({
            value: item.userId,
            lable: item.realName
          });
          this.supplierListCopy.push({
            value: item.userId,
            lable: item.realName
          });
        });
      });
      axiosApi
        .purchasePlanDetail({ planIdList: this.planDetailList })
        .then(response => {
          this.basicForm.secondDeptName = response.content.secondDeptName;
          this.basicForm.planOrderSn = response.content.planOrderSn;
          this.detailList = response.content.detailList;
          axiosApi
            .purchasePlanSave({ planDetailList: this.detailList })
            .then(response => {
              this.issueId = response.content.issueId;
              this.queryList();
            });
        });
      this.queryPage();
    },
    queryPage() {
      this.supstart = this.supstart + 1;
      this.defaultIndex = this.defaultIndex + 12;
      this.loading = true;
      axiosApi
        .supplierPage({
          start: this.supstart,
          size: 12,
          orderRules: [
            { orderKey: "t.recTime", desc: true, nullLast: true },
            { orderKey: "ec.id", desc: true }
          ],
          desc: true
        })
        .then(response => {
          response.content.list.forEach(item => {
            this.supervisorList.push({
              value: item.supplierId,
              lable: item.supplierName
            });
            this.supervisorListCopy.push({
              value: item.supplierId,
              lable: item.supplierName
            });
          });
          this.loading = false;
        });
    },
    submitClick() {
      this.submitLoading = true;
      axiosApi
        .purchasePlanOrderIssue({
          issueId: this.issueId,
          planStatus: 5
        })
        .then(response => {
          this.$router.push({ name: "buyPlan" });
          this.submitLoading = false;
        })
        .catch(error => {
          this.submitLoading = false;
        });
    },
    queryList() {
      var queryParams = {
        planDetailList: this.detailList,
        issueId: this.issueId,
        orderKey: "recTime",
        orderRules: [
          { orderKey: "spuCode", desc: false },
          { orderKey: "colorCode", desc: false },
          { orderKey: "sizeCode", desc: false },
          { orderKey: "t1.id", desc: true }
        ],
        desc: true,
        size: 5,
        start: (this.start - 1) * 5
      };
      axiosApi
        .queryDetailList(queryParams)
        .then(response => {
          this.basicForm.procurementList = response.content.list;
          this.total = response.content.total;
        })
        .catch(error => {});
      axiosApi.queryTotal({ issueId: this.issueId }).then(response => {
        this.basicForm.planIssueQty = response.content.planIssueQty;
        this.basicForm.planQty = response.content.planQty;
        this.basicForm.issueNum = response.content.issueNum;
      }).catch(error => {});
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/buyPlan/buyPlanIssued.vue